"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMicrosoftDomain = exports.isGmailDomain = exports.validateEmail = void 0;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const GMAIL_DOMAINS = ['gmail.com', 'googlemail.com'];
const MICROSOFT_DOMAINS = [
    'outlook.com',
    'hotmail.com',
    'live.com',
    'msn.com',
    'passport.com',
    'outlook.co.uk',
    'hotmail.co.uk',
    'live.co.uk',
];
const validateEmail = (email) => {
    if (!email)
        return false;
    return EMAIL_REGEX.test(email.trim());
};
exports.validateEmail = validateEmail;
const isGmailDomain = (email) => {
    if (!(0, exports.validateEmail)(email))
        return false;
    const domain = email.split('@')[1]?.toLowerCase();
    return domain ? GMAIL_DOMAINS.includes(domain) : false;
};
exports.isGmailDomain = isGmailDomain;
const isMicrosoftDomain = (email) => {
    if (!(0, exports.validateEmail)(email))
        return false;
    const domain = email.split('@')[1]?.toLowerCase();
    return domain ? MICROSOFT_DOMAINS.includes(domain) : false;
};
exports.isMicrosoftDomain = isMicrosoftDomain;
